import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { Divider } from 'antd';
import { useUpdateBreadcrumbParam } from '@/contexts/BreadcrumbContextProvider';
import { PageProps } from '@/types/PageProps';
import WorkOrderComplementTabs from '@/components/Movements/WorkOrders/Details/Complements/WorkOrderComplementTabs';
import { useNotFoundMessage } from '@/hooks/useNotFoundMessage';
import ComplementHeader from '@/components/Movements/WorkOrders/Details/Complements/ComplementHeader';
import { useWorkorderDetailContext } from '@/components/Movements/WorkOrders/Details/WorkorderDetailProvider';
import CommissionsItens from '@/components/Movements/WorkOrders/Details/Commissions/CommissionsItens';
import WorkOrderFooter from '@/components/Movements/WorkOrders/Details/WorkOrderFooter';
import WorkorderTabExtraAction from '@/components/Movements/WorkOrders/Details/WorkorderTabExtraAction';
import workOrderValidationTabs from '@/utils/functions/workOrderValidationTabs';
import { useWorkorderForms } from '@/components/Movements/WorkOrders/Details/WorkOrderFormProvider';
import Authorities from '@/types/Authority';
import { WorkOrderComplementStatus } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { hasPermissions } from '@/utils/functions/hasPermissions';

function WorkOrderCommissionsPage({ route }: PageProps) {
  const intl = useIntl();

  const { hasFormChange, formsValues } = useWorkorderForms();

  const comissionsItems = formsValues.commissions?.items;

  const {
    workorder: { data: workOrder, isLoading: isLoadingWorkOrder },
    complement: {
      data: complement,
      isLoading: isLoadingComplement,
      complementIdentifier,
    },
  } = useWorkorderDetailContext();

  const displayNumber = `${workOrder?.number
    .toString()
    .padStart(6, '0')}/${complement?.number.toString().padStart(2, '0')}`;

  const notFountMessage = useNotFoundMessage('workOrders.domain.customer');

  useUpdateBreadcrumbParam(':workOrderId', displayNumber || notFountMessage);

  return (
    <>
      <Helmet
        title={`${
          complementIdentifier ? `${complementIdentifier} | ` : ''
        }${intl.formatMessage({
          id: route.name,
        })}`}
      />

      <WorkOrderComplementTabs
        route={workOrderValidationTabs(
          route,
          complement?.type,
          complement?.status,
        )}
        permissions={route.permissions}
        isLoading={isLoadingWorkOrder || isLoadingComplement}
        extra={
          <WorkorderTabExtraAction
            saveButtonIsDisabled={
              !comissionsItems?.some((item) => item?.checked) ||
              (complement?.status === WorkOrderComplementStatus.Closed &&
                !hasPermissions([
                  Authorities.MOVIMENTATION_WORKORDER_CLOSED_ADD_COMMISSION,
                  Authorities.MOVIMENTATION_WORKORDER_ADD_EMPLOYEE_TO_COMMISSION,
                ]))
            }
          />
        }
      >
        <>
          <ComplementHeader />

          <CommissionsItens />

          <Divider />

          <WorkOrderFooter disabled={!hasFormChange} />
        </>
      </WorkOrderComplementTabs>
    </>
  );
}

export default WorkOrderCommissionsPage;
